/**
 * @generated SignedSource<<3b9a3d2a46e1a7cec273b5ecf76995d8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type calendarReleaseForMultipleProjects_businessCalendar$data = {
  readonly name: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ui_ReleaseFlyout">;
  readonly " $fragmentType": "calendarReleaseForMultipleProjects_businessCalendar";
};
export type calendarReleaseForMultipleProjects_businessCalendar$key = {
  readonly " $data"?: calendarReleaseForMultipleProjects_businessCalendar$data;
  readonly " $fragmentSpreads": FragmentRefs<"calendarReleaseForMultipleProjects_businessCalendar">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "calendarReleaseForMultipleProjects_businessCalendar",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_ReleaseFlyout"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "e339015d411a63c6030802c78dc22b59";

export default node;
